import { useTilePreferences } from "./TilePreferencesProvider";

export default function useUserTiles() {
  return useTilePreferences();
}
